/* BodyStop (31 Oct 2026): pack-size buttons on product tiles. Loaded once from layout/theme.liquid. */
(function () {
  if (window.customElements.get('bs-pack-picker')) return;

  function money(cents) {
    try {
      if (typeof window.formatMoney === 'function' && window.MinimogSettings && window.MinimogSettings.money_format) {
        return window.formatMoney(cents, window.MinimogSettings.money_format);
      }
    } catch (e) {}
    return 'Rs. ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  class BsPackPicker extends HTMLElement {
    connectedCallback() {
      if (this._bsReady) return;
      this._bsReady = true;
      this.card = this.closest('.m-product-card');
      this.opts = Array.prototype.slice.call(this.querySelectorAll('.bs-pack__opt'));
      var self = this;
      this.opts.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          self.pick(b, false);
        });
      });
      var cur = this.opts.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || this.opts[0];
      if (cur) this.pick(cur, true);
    }

    pick(btn, isInit) {
      var card = this.card;
      if (!card) return;
      this.opts.forEach(function (o) { o.setAttribute('aria-pressed', o === btn ? 'true' : 'false'); });

      var id = btn.dataset.variantId;
      var price = Number(btn.dataset.price) || 0;
      var compare = Number(btn.dataset.compare) || 0;
      var available = btn.dataset.available === 'true';
      var onSale = compare > price;

      // Every Add to cart form on this tile adds the picked pack
      card.querySelectorAll('input[name="id"]').forEach(function (i) {
        i.value = id;
        i.setAttribute('value', id);
      });

      // Price and MRP (the page already shows the right numbers on load)
      if (!isInit) {
        var wrap = card.querySelector('.m-price');
        if (wrap) {
          wrap.classList.toggle('m-price--on-sale', onSale);
          wrap.classList.toggle('m-price--sold-out', !available);
          wrap.querySelectorAll('.m-price-item--sale, .m-price__regular .m-price-item--regular').forEach(function (el) {
            el.textContent = money(price);
          });
          var mrp = wrap.querySelector('.m-price__sale s');
          if (mrp) mrp.textContent = money(onSale ? compare : price);
        }
      }

      // Discount badge on the image, e.g. -23%
      card.querySelectorAll('.m-product-card__tags .m-product-tag--sale').forEach(function (badge) {
        if (!/^-\d+%$/.test(badge.textContent.trim())) return;
        if (onSale) {
          badge.textContent = '-' + Math.floor((compare - price) * 100 / compare) + '%';
          badge.style.display = '';
        } else {
          badge.style.display = 'none';
        }
      });

      var soldBadge = card.querySelector('.m-product-tag--soldout');
      if (soldBadge) soldBadge.style.display = available ? 'none' : 'flex';

      // Add to cart buttons: disable for an out-of-stock pack
      var soldText = this.dataset.soldOut || 'Sold out';
      card.querySelectorAll('.product-card-form button[name="add"]').forEach(function (b) {
        b.disabled = !available;
        b.classList.toggle('disabled', !available);
        var t = b.querySelector('.m-add-to-cart--text');
        if (t) {
          if (!t.dataset.bsText) t.dataset.bsText = t.textContent.trim();
          t.textContent = available ? t.dataset.bsText : soldText;
        }
      });
    }
  }

  window.customElements.define('bs-pack-picker', BsPackPicker);
})();